/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage } from 'react-intl';
import './MsgBox.css'

const MsgBox = (props) => {
    const { type, content, isDisplay } = props;

    return (
        <div className={`msg-box ${type}`} style={{display: isDisplay ? '' : 'none'}}>
            { type==='warning' || type ==='mainWarning' ?
                <div>
                    {content.title.text && <div className={'msg-box-title'} data-key={ content.title.dataKey }>{ content.title.text }</div> }
                    {content.info.text && 
                    <p data-key={ content.info.dataKey }>
                        <FormattedHTMLMessage
                            id={content.info.text}
                            defaultMessage={content.info.text}
                        />
                    </p> }
                </div>
                :
                <div>
                    {content.title.text && <p data-key={ content.title.dataKey }>{ content.title.text }</p> }
                    {content.info.text && 
                    <p data-key={ content.info.dataKey }>
                        <FormattedHTMLMessage
                            id={content.info.text}
                            defaultMessage={content.info.text}
                        />
                    </p> }
                </div>
            }
        </div>
    )
};

MsgBox.propTypes = {
    type: PropTypes.string,
    content: PropTypes.object.isRequired,
    isDisplay: PropTypes.bool
};

MsgBox.defaultProps = {
    content: {},
    isDisplay: true
};

export default MsgBox;


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/MsgBox/index.js